/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { NavCardsSimpleSection } from "./section-list";
import { useGetCurrentWebpage } from "hooks/useGetCurrentWebpage";

const NavCardsSimpleDisplay = () => {
    const webpage = useGetCurrentWebpage();
    const guid = webpage?.guid;
    
    return (
        <div>
            <NavCardsSimpleSection
                webpage_guid={guid}
            />
        </div>
    );
};

NavCardsSimpleDisplay.displayName = "NavCardsSimpleDisplay";
export { NavCardsSimpleDisplay };
